import { connect } from "react-redux";
import Product from "../../components/product/product";
import { Row } from "react-bootstrap";

function Orders({ orders }) {
  return (
    <>
      <h1>Orders</h1>
        {orders.map(({ items, datePlaced }) => (
          <Row key={datePlaced}>
            <p><strong>Placed:</strong> {datePlaced} - {items.length} - items</p>
            {items.map((item) => (
              <Product product={item} hideAddToCart />
            ))}
          </Row>
        ))}
    </>
  );
}

const mapStateToProps = (state) => ({
  orders: state.orders,
});

export default connect(mapStateToProps)(Orders);
